import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Reservation } from "../types/firebase";

interface DeleteReservationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    reservation: Reservation | null;
}

function DeleteReservationModal({ show, onHide, onConfirm, reservation }: DeleteReservationModalProps) {
    return (
        <Modal id="confirmReservationModal" show={show} onHide={onHide} centered className="text-center">
            <Modal.Header className="text-center d-block ">
                <Modal.Title>Cancel Reservation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Confirm you want to cancel this reservation using the button below. This cannot be undone!</p>
            </Modal.Body>
            <Modal.Footer className="footerButtons">
                <Button variant="secondary" onClick={onHide}>
                    Don't Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    Confirm Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteReservationModal;